 /*
创建者 魏强(2018.1.29)
*/
<template>
<div class="module-side">
    <div class="swipe-wrap">
        <div class="swipe" id="leftgoods-swiper1">
            <Carousel
                v-model="value"
                :autoplay="setting.autoplay"
                :autoplay-speed="setting.autoplaySpeed"
                :dots="setting.dots"
                :radius-dot="setting.radiusDot"
                :trigger="setting.trigger"
                :arrow="setting.arrow"
                :height="440"
                :width="300"
            >
                <CarouselItem v-for="item in data" :key="item.key" >
                    <router-link :to="item.to" target="_blank"> 
                        <img :src="item.atturl" height="440px" :alt="item.aname" width="300px" class="scrollLoading">  
                    </router-link>
                </CarouselItem>
            </Carousel>
        </div>
    </div>
</div>
</template>
<script>
import {parseAdvList} from "utils/tool.js";
export default{
    props:["data"],
    data(){
        return {
            list:parseAdvList(this.data),
            value:0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow: 'never'
            } 
        }
    }
}
</script>



// WEBPACK FOOTER //
// left-ad.vue?b1f72f7e